export const getCombinedList = (shopping) => {
  const recipes = shopping.selected
    .map((rec) => {
      return rec.ingredients
        .map((checked, index) => {
          const originalString = rec.recipe.recipeIngredients[index];
          if (rec.recipe.parsedIngredients[index].length === 0) {
            // console.log(rec.quantity, parseInt(rec.recipe.recipeYield));
            return [
              {
                checked,
                original: originalString,
                source: { name: rec.recipe.name, url: rec.recipe.url, index },
                label: null,
                quantity: null,
                multiplier: rec.quantity / parseInt(rec.recipe.recipeYield),
                measurement: null,
              },
            ];
          }
          return rec.recipe.parsedIngredients[index].map((parsed) => {
            return {
              checked,
              original: originalString,
              source: { name: rec.recipe.name, url: rec.recipe.url, index },
              label: parsed.food.label,
              quantity: parsed.quantity,
              multiplier: rec.quantity / parseInt(rec.recipe.recipeYield),
              measurement: parsed.measure?.label,
            };
          });
        })
        .flat();
    })
    .flat();

  const finalList = [];
  while (recipes.length > 0) {
    const currIng = recipes.pop();
    const currentAmt = finalList.find(
      (a) => a.label !== null && a.label === currIng.label
    );
    if (currentAmt !== undefined) {
      currentAmt.originals.push(currIng.original);
      currentAmt.checked.push(currIng.checked);
      currentAmt.quantities.push(currIng.quantity);
      currentAmt.measurements.push(currIng.measurement);
      currentAmt.sources.push(currIng.source);
      currentAmt.multipliers.push(currIng.multiplier);
    } else {
      finalList.push({
        checked: [currIng.checked],
        originals: [currIng.original],
        sources: [currIng.source],
        label: currIng.label,
        quantities: [currIng.quantity],
        multipliers: [currIng.multiplier],
        measurements: [currIng.measurement],
      });
    }
  }
  return finalList;
};
